
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const ModeOfPayment = () => {
  return (
    <SettingsMetaData propertyName={"ModeOfPayment_invoicesIncoming"} viewPropertyName={"Mode Of Payment"} />
  );
};
export default ModeOfPayment;
